const addWidthAndHeightToImages = () => {
  // Get all image
  const images = document.querySelectorAll("img");

  // Loop through all images to check if they have width and height
  images.forEach((image) => {
    // If image does not have width and height
    if (!image.hasAttribute("width") && !image.hasAttribute("height")) {
      // Destructure width and height properties from image
      let { width, height } = image;

      // If the image is not loaded yet, use the natural width and height
      if (width === 0 && height === 0) {
        ({ naturalWidth: width, naturalHeight: height } = image);
      }

      // Add width and height attributes to the image
      image.setAttribute("width", width);
      image.setAttribute("height", height);
    }
  });
};
console.log("");

// Run the function when the HTML is fully loaded
document.addEventListener("DOMContentLoaded", addWidthAndHeightToImages);

/*----------------------------------slick slider----------------------------------*/
if (window.jQuery && window.jQuery.fn && typeof window.jQuery.fn.slick === "function" && jQuery(".threecarousel").length) {

  jQuery(".threecarousel").slick({
    dots: true,
    infinite: true,
    speed: 300,
    lazyLoad: "ondemand",
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          centerPadding: "0px",
        },
      },
      {
        breakpoint: 410,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          centerPadding: "0px",
        },
      },
    ],
  });
}
/*----------------------------------slick slider----------------------------------*/
if (window.jQuery && window.jQuery.fn && typeof window.jQuery.fn.slick === "function" && jQuery(".slide_images").length) {
  jQuery(".slide_images").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    dots: true,
    responsive: [
      {
        breakpoint: 545,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  });

}

/*----------------------------------slick slider----------------------------------*/
if (window.jQuery && window.jQuery.fn && typeof window.jQuery.fn.slick === "function" && jQuery(".onecarousel").length) {
  jQuery(".onecarousel").slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    fade: true,
    cssEase: "linear",
  });
}
/*----------------------------------slick slider----------------------------------*/
if (window.jQuery && window.jQuery.fn && typeof window.jQuery.fn.slick === "function" && jQuery(".centercarousel").length) {
  jQuery(".centercarousel").slick({
    centerMode: true,
    centerPadding: "8vw",
    slidesToShow: 1,
    dots: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          centerPadding: "1vw",
        },
      },
    ],
  });
}
/*----------------------------------slick slider----------------------------------*/

/*----------------------------------hamburger menu starts----------------------------------*/
jQuery(document).ready(function ($) {
  jQuery(".menuicon").on("click", function () {
    var $this = jQuery(this);
    if ($this.hasClass("not-active")) {
      $this.removeClass("not-active").addClass("is-active");
      jQuery(".mobile-nav").hide().delay(1000).fadeIn(500);
      //jQuery('.mobile-nav').addClass('active-nav');
    } else if ($this.hasClass("is-active")) {
      $this.removeClass("is-active").addClass("not-active");
      //jQuery('.mobile-nav').removeClass('active-nav');
      jQuery(".mobile-nav").fadeOut();
    }
    return false;
  });
});

/*----------------------------------hamburger menu ends----------------------------------*/

/*----------------------------------nav menu starts----------------------------------*/

// jQuery( document ).ready(function($) {
// jQuery('.mainnavwrapper > ul > .menu-item-has-children').hoverIntent(function() {
//   jQuery(this).toggleClass('active');
//   jQuery(this).find('.sub-menu:first').slideToggle();
// });

/*jQuery('.mobile-nav > ul > .menu-item-has-children > a').click(function(e) {
  e.preventDefault();
  jQuery(this).toggleClass('activelink');
  jQuery(this).next('.sub-menu').slideToggle();
});*/

//   jQuery('.mobile-nav .menu-item-has-children > a').prop( 'onClick', 'return false' );
// 		jQuery('.mobile-nav .menu-item-has-children a').on("click",function() {
// 			jQuery('.mobile-nav .menu-item-has-children .sub-menu').not(jQuery(this).parents('.sub-menu')).not(jQuery(this).next('.sub-menu')).slideUp();
// 			jQuery(this).next('.sub-menu').slideToggle();
//
// 		});
// 	  	jQuery('.mobile-nav .menu-item-has-children > a').attr( 'onClick', 'return false' );
//
//
//
//
// });

/*mobile nav has child*/

jQuery(".mobile-nav .menu-item-has-children a").after('<a class="icon"></a>');

jQuery(".menu-item-has-children .icon").on("click", function () {
  jQuery(this).toggleClass("iconnavrotate");
  jQuery(this).next().slideToggle();
});

/*----------------------------------nav menu ends----------------------------------*/

//toggle subnav_anchor_sticky on mobile
jQuery(".subnav-anchor-mobile-jump").on("click", function () {
  jQuery(".sub-nav-anchor-mobile").toggleClass("hide");
});

jQuery(document).ready(function ($) {
  jQuery(".searchactivation").on("click", function (e) {
    e.preventDefault();
    jQuery(".searchformwrapper").animate({
      width: "230px",
    });
    jQuery(this).fadeOut();
  });
});

//gform checkbox
jQuery(".gform_wrapper input[type=checkbox]").after(
  '<div class="spana-checkbox"><span style="font-family: Arial Unicode MS, Lucida Grande">&#10003;</span></div>'
);

//accordion
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    this.classList.toggle("active");

    var panel = this.nextElementSibling;

    panel.classList.toggle("hide");
    // if (panel.style.maxHeight){
    //   panel.style.maxHeight = null;
    // } else {
    //   panel.style.maxHeight = panel.scrollHeight + "px";
    // }
  });
}

//lazy loader
jQuery(function () {
  // jQuery(".lazy").lazy({
  //   effect: "fadeIn",
  //   effectTime: 800,
  //   threshold: 0,
  // });
  if (jQuery(".accordion-to-content").length) {
    // if mobile
    if (jQuery(window).width() < 768) {
      let $this = jQuery(".accordion-to-content");
      // find the previous element with the class of container
      let $container = $this
        .prev(".container")
        .find(".col-lg-12.col-xl-6")
        .first();
      // Put the accordion inside the container after the 'col-lg-12 col-xl-6' div
      $container.after($this);
      $this
        .css("margin-top", "5px")
        .css("margin-bottom", "5px")
        .addClass("col-12");
    }
  }
});

/*----date format------*/
var date = document.getElementById("date");

if (date) {
  function checkValue(str, max) {
    if (str.charAt(0) !== "0" || str == "00") {
      var num = parseInt(str);
      if (isNaN(num) || num <= 0 || num > max) num = 1;
      str =
        num > parseInt(max.toString().charAt(0)) && num.toString().length == 1
          ? "0" + num
          : num.toString();
    }
    return str;
  }

  date.addEventListener("input", function (e) {
    this.type = "text";
    var input = this.value;
    if (/\D\/$/.test(input)) input = input.substr(0, input.length - 3);
    var values = input.split("/").map(function (v) {
      return v.replace(/\D/g, "");
    });
    if (values[0]) values[0] = checkValue(values[0], 31);
    if (values[1]) values[1] = checkValue(values[1], 12);
    var output = values.map(function (v, i) {
      return v.length == 2 && i < 2 ? v + " / " : v;
    });
    this.value = output.join("").substr(0, 14);
  });

  date.addEventListener("blur", function (e) {
    this.type = "text";
    var input = this.value;
    var values = input.split("/").map(function (v, i) {
      return v.replace(/\D/g, "");
    });
    var output = "";

    if (values.length == 3) {
      var year =
        values[2].length !== 4
          ? parseInt(values[2]) + 2000
          : parseInt(values[2]);
      var month = parseInt(values[1]) - 1;
      var day = parseInt(values[0]);
      var d = new Date(year, month, day);
      if (!isNaN(d)) {
        document.getElementById("result").innerText = d.toString();
        var dates = [d.getMonth() + 1, d.getDate(), d.getFullYear()];
        output = dates
          .map(function (v) {
            v = v.toString();
            return v.length == 1 ? "0" + v : v;
          })
          .join(" / ");
      }
    }
    this.value = output;
  });
}

//append line break on donation form
jQuery(
  "#ffm-contact_consent_au > label:first-of-type, #contact_consent-wrap"
).addClass("form-border-bottom");

jQuery(document).ready(function ($) {
  if (jQuery("input.wdgk_donation").length) {
    jQuery("input.wdgk_donation").attr("min", "0");
  }

  if (jQuery('.woocommerce div.product form.cart').length > 0 || jQuery('.woocommerce table.shop_table').length > 0) {
    if (jQuery('.woocommerce div.product form.cart div.quantity').hasClass('hidden')) {
      jQuery('.woocommerce div.product form.cart div.quantity').siblings('.minusbtn').remove();
      jQuery('.woocommerce div.product form.cart div.quantity').siblings('.plusbtn').remove();
      // Using attr because !important is used in the css
      jQuery('.woocommerce div.product form.cart .single_add_to_cart_button').attr('style', 'margin-left: 0 !important;');
    }

    // Check if type is hidden
    if (jQuery('.woocommerce-cart table.cart input.quantity').attr('type') == 'hidden') {
      jQuery('.woocommerce-cart table.cart input.quantity').siblings('.minusbtn').remove();
      jQuery('.woocommerce-cart table.cart input.quantity').siblings('.plusbtn').remove();
    }
  }
});
